module.exports = __webpack_public_path__ + "img/status_bg.e31783c0.png";